import React from 'react';
import { sortBy } from 'lodash';
import FilterPill from '@src/components/filter-panel/FilterPill';
import { FIXED_FILTERS } from '@src/components/filter-panel/constants';

const RECENT_FILTERS_LIMIT = 5;

const isFilterSelected = (filter, appliedFilter): boolean => (filter.fid && filter.fid === appliedFilter.id) || appliedFilter.name === filter.name;

// Recent Filters
export function buildRecentFilterPills(filters, appliedFilter, onClickRecentFilter) {
  const sortedFilters = sortBy(filters, ['created']).reverse();
  const fixedFiltersNames = new Set(FIXED_FILTERS.map(f => f.name));

  const recentFilters = sortedFilters
    .filter((filter: any) => !fixedFiltersNames.has(filter.name) && filter.enabled)
    .slice(0, RECENT_FILTERS_LIMIT)
    .map((filter: any) => (
      <FilterPill
        key={filter.fid || filter.name}
        checked={isFilterSelected(filter, appliedFilter)}
        filter={filter}
        onChange={onClickRecentFilter(filter)}
        isCheckbox={false}
      />
    ));

  return recentFilters;
}

// default filters
export function buildDefaultFilterPills(appliedFilter, onClickRecentFilter) {
  const defaultFilters = FIXED_FILTERS.map(filter => (
    <FilterPill
      key={filter.fid || filter.name}
      checked={isFilterSelected(filter, appliedFilter)}
      filter={filter}
      onChange={onClickRecentFilter(filter)}
      isCheckbox={false}
      // disabled={filters.length === 0}
    />
  ));
  return defaultFilters;
}
